import * as Constants from '../constants/pet';

export const getUserPets = ($http, ENV, userId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_USER_PETS_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/pets/`,
      params: { owner: userId },
    })
      .then((res) => {
        dispatch({ type: Constants.GET_USER_PETS_SUCCESS, payload: res.data.pets });
        resolve(res.data.pets);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_USER_PETS_FAILED, payload: error });
        reject(error);
      });
  });

export const createProPet = ($http, ENV, petInfo) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.CREATE_PRO_PET_REQUEST });

    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/1.0/pets/`,
      data: petInfo,
    })
      .then((res) => {
        dispatch({ type: Constants.CREATE_PRO_PET_SUCCESS, payload: res.data.pet });
        resolve(res.data.pet);
      })
      .catch((error) => {
        dispatch({ type: Constants.CREATE_PRO_PET_FAILED, payload: error });
        reject(error);
      });
  });

export const updateProPet = ($http, ENV, petId, petInfo) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_PRO_PET_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/1.0/pets/${petId}/`,
      data: petInfo,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_PRO_PET_SUCCESS, payload: res.data.pet });
        resolve(res.data.pet);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_PRO_PET_FAILED, payload: error });
        reject(error);
      });
  });

export const createProPetProvider = ($http, ENV, petId, providerInfo) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.CREATE_PRO_PET_PROVIDER_REQUEST });

    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/1.0/pets/${petId}/providers/`,
      data: providerInfo,
    })
      .then((res) => {
        dispatch({
          type: Constants.CREATE_PRO_PET_PROVIDER_SUCCESS,
          payload: res.data.petProvider,
        });
        resolve(res.data.petProvider);
      })
      .catch((error) => {
        dispatch({ type: Constants.CREATE_PRO_PET_PROVIDER_FAILED, payload: error });
        reject(error);
      });
  });

export const updateProPetProvider = ($http, ENV, petId, providerSlug, providerInfo) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_PRO_PET_PROVIDER_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/1.0/pets/${petId}/providers/${providerSlug}/`,
      data: providerInfo,
    })
      .then((res) => {
        dispatch({
          type: Constants.UPDATE_PRO_PET_PROVIDER_SUCCESS,
          payload: res.data.petProvider,
        });
        resolve(res.data.petProvider);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_PRO_PET_PROVIDER_FAILED, payload: error });
        reject(error);
      });
  });

export const getPet = ($http, ENV, petId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_PET_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/pets/${petId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_PET_SUCCESS, payload: res.data.pet });
        resolve(res.data.pet);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_PET_FAILED, payload: error });
        reject(error);
      });
  });

export const getSpecies = ($http, ENV, params) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_SPECIES_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/pets/species/`,
      params: params,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_SPECIES_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_SPECIES_FAILED, payload: error });
        reject(error);
      });
  });

export const getBreeds = ($http, ENV, species) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_BREEDS_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/breeds/`,
      params: species !== '' ? { species } : {},
    })
      .then((res) => {
        dispatch({ type: Constants.GET_BREEDS_SUCCESS, payload: res.data.breeds });
        resolve(res.data.breeds);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_BREEDS_FAILED, payload: error });
        reject(error);
      });
  });

export const getGenders = () => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_GENDERS_REQUEST });

    resolve({
      'pets-gender': [
        { name: 'Male', value: true },
        { name: 'Female', value: false },
      ],
    });
  });

export const getStatuses = () => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_STATUSES_REQUEST });

    resolve({
      'pets-statuses': [
        { name: 'Active', value: true },
        { name: 'Archived', value: false },
      ],
    });
  });

export const getNeutered = () => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_NEUTERED_REQUEST });

    resolve({
      'pets-neutered': [
        { name: 'Neutered less than 4 months old', value: 'LTS' },
        { name: 'Neutered between 4-12 months', value: 'STT' },
        { name: 'Neutered when older than 1 year', value: 'OOY' },
        { name: 'Neutered but unsure at what age', value: 'UNS' },
        { name: 'Not neutered, I plan to breed him', value: 'YE' },
        { name: 'Not neutered, I don’t plan to breed him', value: 'NO' },
        { name: 'Not neutered, not decided about breeding him', value: 'NS' },
        { name: 'Unsure if neutered', value: 'UN' },
      ],
    });
  });

export const getSpayed = () => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_NEUTERED_REQUEST });

    resolve({
      'pets-spayed': [
        { name: 'Spayed less than 4 months old', value: 'LTS' },
        { name: 'Spayed between 4-12 months', value: 'STT' },
        { name: 'Spayed when older than 1 year', value: 'OOY' },
        { name: 'Spayed but unsure at what age', value: 'UNS' },
        { name: 'Not spayed, I plan to breed her', value: 'YE' },
        { name: 'Not spayed, I don’t plan to breed her', value: 'NO' },
        { name: 'Not spayed, not decided about breeding her', value: 'NS' },
        { name: 'Unsure if spayed', value: 'UN' },
      ],
    });
  });

export const getDeclawedOptions = () => (dispatch) =>
  new Promise((resolve) => {
    dispatch({ type: Constants.GET_DECLAWED_REQUEST });
    resolve({
      petsDeclawedOptions: [
        { name: 'Not declawed', value: '' },
        { name: 'Front paws declawed ', value: 'F' },
        { name: 'Back paws declawed ', value: 'R' },
        { name: 'All paws declawed ', value: 'FR' },
      ],
    });
  });

export const getMedicalConditionOptions = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    const baseConditions = {
      'pets-medical-conditions': [
        { name: 'Eyes', value: 'eyes' },
        { name: 'Ears', value: 'ears' },
        { name: 'Teeth and Mouth', value: 'teeth_and_mouth' },
        { name: 'Skin and Coat', value: 'skin_and_coat' },
        { name: 'Heart', value: 'heart' },
        { name: 'Breathing', value: 'breathing' },
        { name: 'Bones and Joints', value: 'bones_and_joints' },
        { name: 'Alertness and Balance', value: 'alertness_and_nerves' },
        { name: 'Urinary Tract', value: 'bathroom_habits_urine' },
        { name: 'Cancer', value: 'cancer' },
        { name: 'Digestion', value: 'digestion' },
      ],
    };

    dispatch({ type: Constants.GET_MEDICAL_CONDITIONS_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + '/2.0/pets/medical-conditions/',
    })
      .then((res) => {
        const moreConditions = res.data['pets-medical-conditions']
          .map((condition) => {
            return condition.is_active ? { name: condition.name, value: condition.slug } : {};
          })
          .filter((condition) => Object.keys(condition).length !== 0);
        const allConditions = {
          'pets-medical-conditions': baseConditions['pets-medical-conditions'].concat(
            moreConditions,
          ),
        };
        dispatch({ type: Constants.GET_MEDICAL_CONDITIONS_SUCCESS, payload: allConditions });
        resolve(allConditions);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_MEDICAL_CONDITIONS_FAILED, payload: error });
        reject(error);
      });
  });

export const getOwnerIdentifications = () => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_OWNER_IDENTIFICATIONS_REQUEST });

    resolve({
      'pets-owner-identifications': [
        { name: 'ID Collar / Harness', value: 'id_has_collar' },
        { name: 'ID Tag', value: 'id_has_tag' },
        { name: 'Microchip', value: 'id_has_id_chip' },
      ],
    });
  });

export const getPetHealth = ($http, ENV, petId, category, slug) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_PET_HEALTH_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/pets-health/${petId}/${category}/${slug}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_PET_HEALTH_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_PET_HEALTH_FAILED, payload: error });
        reject(error);
      });
  });

export const setActivePet = (pet) => ({
  type: Constants.SET_ACTIVE_PET,
  payload: pet,
});

export const setUserPets = (pets) => ({
  type: Constants.SET_USER_PETS,
  payload: pets,
});
